import React from 'react';
import { Helmet } from 'react-helmet'
// import 'bootstrap/dist/js/bootstrap.bundle';


const Script = () => {

    return (
        <div>

            <Helmet>
                <script src="assets/js/hyper-config.js"></script>

                <script src="assets/js/vendor.min.js"></script>

                <script src="assets/js/app.min.js"></script>

                



            </Helmet>
        </div>
    )
}

export default Script
